'use client'

import React, { ReactElement } from 'react'
import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import ChevronRightIcon from '@/icons/font-awesome/sharp-light/chevron-right.svg'

export default function ShowDetailsButton(props: {
  onClick?: (e: React.MouseEvent<HTMLParagraphElement>) => void
  colorLight?: boolean
}): ReactElement {
  const t = useTranslations('Hotel.Programs.ShowDetailsButton')
  return (
    <div className="flex">
      <p
        onClick={props.onClick}
        className={classNames('flex cursor-pointer justify-center text-xs', {
          'text-stone-600': !props.colorLight,
          'text-stone-400': props.colorLight,
        })}
      >
        {t('moreDetailsButtonLabel')}{' '}
        <ChevronRightIcon
          className={classNames('ml-1 mt-1.5 h-3 w-3', {
            'fill-stone-400': props.colorLight,
            'fill-stone-600': !props.colorLight,
          })}
        />
      </p>
    </div>
  )
}
